// extracted by mini-css-extract-plugin
module.exports = {"postSocial":"styles-module--postSocial--1NVJc","text":"styles-module--text--I-jfw","button":"styles-module--button--39kv0 _utils--focus--34PQG"};